import { h, ComponentChildren } from 'preact'

type Props = {
    children: ComponentChildren
}

const MethodBox = ({ children }: Props) =>
  <div class='method-box'>
    {children}
  </div>

export default MethodBox
